import axios from 'axios'

export default class HashChecker {
  private readonly hash: string
  constructor(hash: string) {
    this.hash = hash
  }

  check() {
    const client = axios.create({
      baseURL: process.env.REACT_APP_BACKEND_URL,
      headers: {
        'Content-Type': 'application/json',
        'Origin': window.location.origin,
      },
      responseType: 'json'
    })
    return client.get<responseHashCheck>(`/exists/${this.hash}`)
  }
}
